import { Col, Row, Image } from 'react-bootstrap';
import Default from './layout/Default';
import LoginImage from '../assets/images/login-img.png';

const PageNotFound = () => {

    return (
        
            <Default>
                <Row className="loginPage">
                <div className="d-flex align-items-center justify-content-center vh-90">
                <div className="text-center">
                  <h1 className="display-1 fw-bold">404</h1>
                  <p className="fs-3">
                    {" "}
                    <span className="text-danger">Opps!</span> Page not found.
                  </p>
                  <p className="lead">
                    The page you’re looking for doesn’t exist.
                  </p>
                </div>
              </div>
                </Row>
            </Default>
        
    )
}

export default PageNotFound;